import React from 'react';
import styled from 'styled-components';

import { Button } from '@hoffmann/pattern-library-2';

import { useApp } from '../../hooks/useApp';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { ID_TOKEN } from '../../providers/AppContext/AppContext';
import ClipboardCopy from '../ClipboardCopy/ClipboardCopy';
import { StyledModal } from '../StyledModal/StyledModal';

interface Props {
  onClose: () => void;
}

export const TechnicalAboutModal: React.FC<Props> = ({ onClose }) => {
  const { loggedIn, userId, username, roles } = useApp();
  const [token] = useLocalStorage<string>(ID_TOKEN);
  return (
    <StyledModal
      width="730px"
      isOpen={true}
      title="Technical Details"
      onClickOutside={onClose}
      onEscPressed={onClose}
    >
      <Styles>
        <Row label="User ID:" value={userId} clipboard={userId} />
        {loggedIn && (
          <>
            <Row label="User name:" value={username} />
            <Row label="User roles:" value={roles.join(', ')} />
            <Row label="Authentication token:" clipboard={token} />
            <Row label="Git branch:" value={process.env.REACT_APP_GIT_BRANCH} />
            <Row label="Git commit:" value={process.env.REACT_APP_GIT_SHA} />
          </>
        )}
        <Buttons>
          <Button label="Close" theme="brand" onClick={onClose} />
        </Buttons>
      </Styles>
    </StyledModal>
  );
};

interface RowProps {
  label: string;
  value?: string | React.ReactNode;
  clipboard?: string;
}
const Row: React.FC<RowProps> = ({ label, value, clipboard }) => {
  return (
    <StyledRow>
      <Label>{label}</Label>
      <Value>
        {value && <span>{value}</span>}
        {clipboard && (
          <span>
            <ClipboardCopy value={clipboard} />
          </span>
        )}
      </Value>
    </StyledRow>
  );
};

const Styles = styled.div`
  > div + div {
    margin-top: 0.5rem;
  }
`;
const StyledRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  width: 100%;

  > button + button {
    margin-left: 1rem;
  }
`;

const Label = styled.div`
  flex: 0 0 150px;
  display: flex;
`;
const Value = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 auto;
  width: 100%;

  > span + span {
    margin-left: 0.5rem;
  }
`;
